<form [formGroup]="airplayPresetForm">
  <div class="d-flex">
    <ng-content select="[title]"></ng-content>
    @if (allowToggle()) {
      <button type="button"
              class="btn btn-outline-primary border-0 ms-auto"
              (click)="toggleEditing()">
        @if (!editing) {
          <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
        } @else {
          <fa-icon [icon]="['far', 'save']"></fa-icon>
        }
      </button>
    }
  </div>
  <table class="table table-sm table-list">
    <thead>
      <tr>
        <th colspan="2"
            scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <!-- securityType -->
      <tr>
        <th title="Required. Must be one of the defined values: PASSCODE_ONCE, PASSCODE_ALWAYS, or PASSWORD. PASSCODE_ONCE will require an on-screen passcode to be entered on the first connection from a device. Subsequent connections from the same device will not be prompted. PASSCODE_ALWAYS will require an on-screen passcode to be entered upon every AirPlay connection. PASSWORD will require a passphrase to be entered as specified in the Password key. The Password key is required if this SecurityType is selected. NONE was deprecated in tvOS 11.3. Existing profiles using NONE will get the PASSWORD_ONCE behavior."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="securityType"
                 class="col-form-label"
                 i18n>Security Type</label>
        </th>
        <td>
          @if (!editing) {
            <label for="securityType"
                   class="col-form-label">{{ airplayPreset()?.securityType }}</label>
          } @else {
            <select id="securityType"
                    formControlName="securityType"
                    class="form-select">
              <option value="PASSCODE_ONCE"
                      i18n>PASSCODE_ONCE</option>
              <option value="PASSCODE_ALWAYS"
                      i18n>PASSCODE_ALWAYS</option>
              <option value="PASSWORD"
                      i18n>PASSWORD</option>
            </select>
          }
        </td>
      </tr>

      <!-- accessType -->
      <tr>
        <th title="Required. Must be one of the defined values: ANY or WIFI_ONLY. ANY allows connections from both Ethernet/WiFi and AWDL. WIFI_ONLY allows connections only from devices on the same Ethernet/WiFi network as the Apple TV"
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="accessType"
                 class="col-form-label"
                 i18n>Access Type</label>
        </th>
        <td>
          @if (!editing) {
            <label for="accessType"
                   class="col-form-label">{{ airplayPreset()?.accessType }}</label>
          } @else {
            <select id="accessType"
                    formControlName="accessType"
                    class="form-select">
              <option value="ANY"
                      i18n>ANY</option>
              <option value="WIFI_ONLY"
                      i18n>WIFI_ONLY</option>
            </select>
          }
        </td>
      </tr>

      <!-- password -->
      <tr>
        <th title="The AirPlay password."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="password"
                 class="col-form-label"
                 i18n>Password</label>
        </th>
        <td>
          <div class="input-group d-flex">
            @if (!editing && airplayPreset()?.password) {
              <label for="password"
                     class="col-form-label position-static">{{
              showPassword ? airplayPreset()?.password : '******'
              }}</label>
            }
            @if (editing) {
              <input [attr.type]="showPassword ? 'text' : 'password'"
                     class="form-control position-static"
                     id="password"
                     formControlName="password" />
            }
            @if (airplayPreset()?.password && editing) {
              <div>
                <button type="button"
                        class="btn btn-outline-primary border-gray-400"
                        (click)="showPassword = !showPassword">
                  @if (!showPassword) {
                    <fa-icon icon="eye"></fa-icon>
                  } @else {
                    <fa-icon icon="eye-slash"></fa-icon>
                  }
                </button>
              </div>
            }
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</form>